"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiLicense = void 0;
// https://mui.com/x/introduction/licensing/#license-key-security
exports.muiLicense = 'aaa270291792cd8f87570a6a415170b3Tz05NjgxNyxFPTE3NTYwNDQzNjIwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPWluaXRpYWwsS1Y9Mg==';
//# sourceMappingURL=muiLicense.js.map